import { AfterViewInit, Component, DoCheck, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ScreenSeatsMultiSeatComponent } from 'libs/shared/src/lib/component/screen/seats/component/multiseat/multiseat.component';
import { environment } from 'apps/cinema1/src/environments/environment';

@Component({ standalone: false, selector: 'app-screen-seats-multiseat', templateUrl: './multiseat.component.html' })
export class CustomAppScreenSeatsMultiSeatComponent extends ScreenSeatsMultiSeatComponent implements OnInit, DoCheck, AfterViewInit {
  constructor(protected translateService: TranslateService) {
    super(environment, translateService);
  }
}
